import React, { Component } from 'react';
import { Container, Tabs, Tab } from 'react-bootstrap';
import { GoBook, GoDatabase, GoHistory, GoGear, GoSync } from 'react-icons/go';

export default class BlobTabs extends Component {
  handleTabSelect(tabSection) {
    const orgId = this.props.match.params.orgId;
    const blobId = this.props.match.params.blobId;

    // Redirect to corresponding page
    var pagePath = `\/${orgId}\/${blobId}`;
    if ( "default" == tabSection && this.props.forcedRevision ) {
      pagePath += `\/revisions\/${this.props.revision.id}`;
    } else if ( "default" != tabSection ) {
      pagePath += `\/${tabSection}`;
    }
    this.props.history.push(pagePath);
  }

  render() {
    return (
      <>
        <Container className="blob-header-row main-tabs">
          <Tabs defaultActiveKey="default" activeKey={this.props.section} onSelect={(key) => this.handleTabSelect(key)}>
            {this.props.revision && "draft" == this.props.revision.phase &&
              <Tab eventKey="default" title={<><GoDatabase/> Draft</>}></Tab>
            }
            {this.props.revision && "commit" == this.props.revision.phase &&
              <Tab eventKey="default" title={<><GoDatabase/> Commit</>}></Tab>
            }
            {this.props.revision && "snapshot" == this.props.revision.phase &&
              <Tab eventKey="default" title={<><GoDatabase/> Snapshot</>}></Tab>
            }
            {!this.props.revision &&
              <Tab eventKey="default" title={<><GoDatabase/> Loading...</>}></Tab>
            }
            <Tab eventKey="revisions" title={<><GoHistory/> Revisions</>}></Tab>
            <Tab eventKey="settings" title={<><GoGear/> Settings</>} disabled></Tab>
          </Tabs>
        </Container>
      </>
    )
  }
}
